import React, { useEffect, useState } from 'react';
import api from '../../seller-apis/api'
import './Leads.css';
import { Route, NavLink, useRouteMatch, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { fetchunansQA,fetchansQA,fetchIgnoredQA } from "../../seller-apis/apidataField";
import LeadsTabs from './LeadsTabs';
import LeadList from './LeadList';
import LeadsManagement from './LeadsManagement';


function CustomerLeads(props) {
    const { path, url } = useRouteMatch();
    const [pendingCount, setPendingCount] = useState(0);
    const [answeredCount, setAnsweredCount] = useState(0);
    const [ignoredCount, setIgnoredCount] = useState(0);
    const stateData = useSelector((state) => state);
    
      useEffect(() => {
        if(stateData.ActionReducer.PendingQuestionCount!=null)
        {
        // api.QandA.fetchQA(fetchunansQA({pageNo: "1", size:1, type:"NEW"})).then((res) => {
        //   setPendingCount(res.totalRecords);
        // });
        // setPendingCount(stateData.ActionReducer.PendingQuestionCount);
        api.QandA.QuestionAnswerCount({}).then((res) => {
          // console.log(res?.data.data.records);
          res?.data.data.records.forEach(element => {
            element.questionType=='NEW'&&setPendingCount(element.count);
            element.questionType=='ANSWERED'&&setAnsweredCount(element.count);
            element.questionType=='IGNORED'&&setIgnoredCount(element.count);
            
          });
          // setAnsweredCount(res.totalRecords)
        });
        // api.QandA.fetchQA(fetchunansQA({pageNo: "1", size:1, type:"IGNORED"})).then((res) => {
        //   setIgnoredCount(res.totalRecords)
        // });
    }
      }, [stateData.ActionReducer.PendingQuestionCount]);
    return (
        <>
            <div className=''>

             {/* <LeadsTabs /> */}
                
            </div>
            <div>
                <Route exact path="/customer-leads">
                    <Redirect to={`${path}/details`} />
                </Route>
                <Route path={`${path}/Management`} component={LeadsManagement} />
                <Route path={`${path}/details`} component={LeadList} />
                
            </div>
        </>
    )




}


export default CustomerLeads;